import { AppShell } from '../components/shell/AppShell';
import { SignInButton } from '../SignInButton';
import { HeroPanel } from '../components/shared/HeroPanel';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { Outlet } from 'react-router-dom';
import { Button, Spin } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { useSession } from '../UserContext';

/** MSAL calls a cached account "authenticated", but every page below needs a token. */
function SessionGate() {
  const { signInAgain, status } = useSession();

  if (status === 'acquiring') {
    return (
      <div style={{ padding: '72px 24px', textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (status === 'sign-in-required') {
    return (
      <HeroPanel
        subtitle="We couldn't refresh your session. Sign in again to continue."
        title="Your session expired"
      >
        <Button
          icon={<LoginOutlined />}
          onClick={() => void signInAgain()}
          size="large"
          type="primary"
        >
          Sign In
        </Button>
      </HeroPanel>
    );
  }

  return <Outlet />;
}

export function AuthLayout() {
  return (
    <>
      <AppShell />
      <UnauthenticatedTemplate>
        <HeroPanel
          subtitle="Sign in to access your clients, agents, and insights."
          title="Welcome to HouseWhisper"
        >
          <SignInButton loginType="popup" />
        </HeroPanel>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <SessionGate />
      </AuthenticatedTemplate>
    </>
  );
}
